import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import WarehouseInMiddleware from "../../../middleware/modules/warehouse/warehouse-in";
import PrintWHIn from "../../../components/utilities/print/default/warehouse-in";
// components
// middlewares

const mapStateToProps = ({ auth, warehousein }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: auth.isProcessing,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  dataPrint: warehousein.printWHIn,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (id) => WarehouseInMiddleware.getPrint(id),
    },
    dispatch
  );
};

class WHInContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.id);
  }

  render() {
    const {
      isAuthenticated,
      isProcessing,
      isRegistered,
      isError,
      errorMessage,
    } = this.props;
    return <PrintWHIn {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WHInContainer);
